import React from 'react';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import className from 'classnames';
import { Text, Title, Box } from '@nerdwallet/currency';

import CompoundInterestCalculator from '../compound-interest-calculator/compound-interest-calculator';
import {
  stringInputSpec,
  stringTextAreaSpec,
  anchorIdInput,
} from '../../lib/editing-configs';
import './editable-interest-calculator.less';

const EditableInterestCalculator = ({
  title,
  subtitle,
  footnote,
  chartSummaryHeading,
  chartSummaryBody,
  anchorId,
}) => (
  <Box
    className={className([
      'landing-page-standard__max-widths',
      classes('margin-horizontal-auto'),
    ])}
    id={anchorId}
  >
    <Title size="small" className="editable-interest-calculator-title">
      {title}
    </Title>
    <Box className={classes('padding-vertical-3')}>
      <Text>{subtitle}</Text>
    </Box>
    <CompoundInterestCalculator
      summaryHeading={chartSummaryHeading}
      summaryBody={chartSummaryBody}
    />
    <Box className={classes(['padding-top-3', 'padding-bottom-5'])}>
      <Text component="p" size="small">
        {footnote}
      </Text>
    </Box>
  </Box>
);

EditableInterestCalculator.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  footnote: PropTypes.string,
  anchorId: PropTypes.string,
  chartSummaryHeading: PropTypes.string,
  chartSummaryBody: PropTypes.string,
};

EditableInterestCalculator.getEditingConfig = () => [
  stringInputSpec('title', 'Title'),
  stringTextAreaSpec('subtitle', 'Subtitle'),
  stringTextAreaSpec('footnote', 'Footnote'),
  stringInputSpec('chartSummaryHeading', 'Chart summary title'),
  stringTextAreaSpec('chartSummaryBody', 'Chart summary body'),
  anchorIdInput,
];

EditableInterestCalculator.displayName = 'EditableInterestCalculator';

export default EditableInterestCalculator;
